import moment, { type Moment } from 'moment';

import type { RenderableContentArtifact } from '@/hooks/useContentArtifacts';

import type { Action } from '../../../../bridge/types/action.ts';

export const validMoment = (input: unknown): Moment | null => {
	if (typeof input !== 'string' || !input) return null;
	const m = moment(input);
	return m.isValid() ? m : null;
};

export const emailSendDate = (
	artifact: RenderableContentArtifact,
	action: Action | undefined,
): Moment | null => {
	if (artifact.type !== 'email_html' && artifact.type !== 'email_plaintext') {
		return null;
	}
	const fromSendStatus = validMoment(action?.outputs?.send_status?.at);
	if (fromSendStatus) return fromSendStatus;
	if (action?.trigger?.type === 'scheduled_once') {
		return validMoment(action.trigger.timestamp);
	}
	return null;
};

export const formatSendDate = (date: Moment) => date.format('dddd MM/DD');
